import { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';

import auth from '../../../../services/authService';
import ChartsPill from '../ChartsPill';
import SongChartsModal from '../SongChartsModal';
import { getChartCoverage, getChartedParts, isChartDrawn } from '../../../../utils/partCharts';
import { computePartNumbers } from '../../../../utils/partNumbers';

// The parts as stored, so Hide Chords doesn't change the count
const storedParts = (song) => song.originalParts || song.parts;

/** Whether the song has a chart to badge. Callers check first, since SongBadges skips an empty row. */
export const hasChartsBadge = (song) => getChartedParts(storedParts(song)).length > 0;

// The charts pill and the modal it opens, for one song
const SongChartsBadge = ({ song, from }) => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const parts = storedParts(song);
  const chartedParts = getChartedParts(parts);
  const coverage = getChartCoverage(parts);
  const currentUser = auth.getCurrentUser();
  const canEditSong = Boolean(currentUser?.isAdmin && currentUser.teamId === song.team._id);

  const handleEditPart = (part) => {
    setIsOpen(false);
    history.push({
      pathname: `/songs/${song._id}`,
      search: `?editPartId=${part.id}`,
      state: { from: from ?? location.pathname + location.search + location.hash },
    });
  };

  return (
    <>
      <ChartsPill
        charted={coverage.total - coverage.missing.length}
        total={coverage.total}
        hasLyricsCharts={chartedParts.some((part) => !isChartDrawn(part))}
        onOpen={() => setIsOpen(true)}
      />
      <SongChartsModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        parts={chartedParts}
        coverage={coverage}
        onEditPart={canEditSong ? handleEditPart : undefined}
        partNumbers={computePartNumbers(song.parts)}
        timeSignature={song.timeSignature}
      />
    </>
  );
};

SongChartsBadge.propTypes = {
  song: PropTypes.object.isRequired,
  /** Where the editor's back button returns to; the current page when left out */
  from: PropTypes.string,
};

export default SongChartsBadge;
